// Cyannect internal team roles (Super Admin portal only). The backend enforces every permission; this only shapes the UI.
export const INTERNAL_ROLES = ["super_admin", "admin", "finance", "operations", "support"];
export const DELEGATED_ROLES = ["finance", "operations", "support"];

export const ROLE_LABELS = {
  super_admin: "Super Admin", admin: "Admin", finance: "Finance", operations: "Operations", support: "Support",
};

export const ROLE_HINTS = {
  super_admin: "Everything, including the team, pricing and security settings",
  admin: "Day-to-day platform admin — no team, pricing or security changes",
  finance: "Billing, invoices, refunds and Performance Fee reviews",
  operations: "Merchants, campaigns, gift cards and sponsored cashback",
  support: "Support tickets and read-only merchant info",
};

export const ROLE_RANK = { support: 1, operations: 2, finance: 2, admin: 3, super_admin: 4 };

export const STATUS_META = {
  invited: ["Invited", "pf-chip-lav"],
  active: ["Active", "pf-chip-mint"],
  suspended: ["Suspended", "bg-amber-100 text-amber-800"],
  revoked: ["Revoked", "bg-red-50 text-red-700"],
  invite_expired: ["Invite expired", "bg-slate-100 text-slate-600"],
};

export const isInternalRole = (role) => INTERNAL_ROLES.includes(role);

export function apiMessage(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  return d?.message || fallback;
}
